import React, { useContext } from 'react';
import { CurrentPageContext } from '../../contexts';

const SidenavMenu: React.FC = () => {
  const { currentPage, setCurrentPage } = useContext(CurrentPageContext);

  return (
    <ul id="slide-out" className="sidenav">
      <li>
        <div className="logo">
          <div className="background">
            <img src={require('../../../images/products/TheVendingSuppliersLogo.png')} alt='focaccia_freaks_logo' />
          </div>
        </div>
      </li>
      <li>
        <p className="subheader">Focaccia Freaks</p>
      </li>
      <li>
        <a
          href='#home'
          onClick={() => {
            setCurrentPage('home');
          }}
          className={
            currentPage === 'home' ? 'waves-effect active' : 'waves-effect'
          }
        >
          <span className="material-icons">home</span>Homepage
        </a>
      </li>
      <li>
        <a
          href='#browse'
          onClick={() => {
            setCurrentPage('browse');
          }}
          className={
            currentPage === 'browse' ? 'waves-effect active' : 'waves-effect'
          }
        >
          <span className="material-icons">shopping_cart</span>Browse Offers
        </a>
      </li>
      <li>
        <a
          href='#cart'
          onClick={() => {
            setCurrentPage('cart');
          }}
          className={
            currentPage === 'cart' ? 'waves-effect active' : 'waves-effect'
          }
        >
          <span className="material-icons">local_shipping</span>Send Enqiury
        </a>
      </li>
      <li>
        <div className="divider"></div>
      </li>
      <li>
        <a
          href='#about'
          onClick={() => {
            setCurrentPage('about');
          }}
          className={
            currentPage === 'about' ? 'waves-effect active' : 'waves-effect'
          }
        >
          About Us
        </a>
      </li>
      <li>
        <a
          href='#contact'
          onClick={() => {
            setCurrentPage('contact');
          }}
          className={
            currentPage === 'contact' ? 'waves-effect active' : 'waves-effect'
          }
        >
          Contact Us
        </a>
      </li>
    </ul>
  );
};

export default SidenavMenu;
